<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Time off Periods</p>
      </div>
      <div class="flex justify-between items-center">
        <div class="flex items-center">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          ></el-pagination>

          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="p-2 bg-gray-200 w-52 m-2 py-1 rounded-md"
          />
        </div>

        <div class="flex items-center gap-3">
          <div
            @click="exportTemplate"
            class="bg-primary flex text-white items-center text-sm px-3 py-2.5 rounded-md cursor-pointer gap-2"
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" alt="" />
            <p>Export</p>
          </div>

          <button
            @click="showCreateLeavePeriod = true"
            class="border-1.5 rounded-full px-2 py-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            Create
          </button>
        </div>
      </div>

      <!-- search -->
      <div class="px-2 pb-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showAddDepartmentSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ add_dept_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ showLocDelSuccess }}
          </div>
        </transition>

        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Periods found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateLeavePeriod
      @close="handleClose"
      :showCreateLeavePeriod="showCreateLeavePeriod"
      @closeOnSuccess="handleCloseOnSuccess"
      :reload="reload"
      :latestDate="latestDate"
      :info="createInfoObject()"
    >
    </CreateLeavePeriod>

    <AddDepartment
      @close="handleClose"
      :showAddDepartment="showAddDepartment"
      :selectedRow="selectedRow"
      @closeOnSuccess="handleCloseOnAddDept"
    ></AddDepartment>

    <EditLeavePeriod
      @close="handleClose"
      :showEditLeavePeriod="showEditLeavePeriod"
      :leavePeriodToEdit="leavePeriodToEdit"
      @closeOnSuccess="handleCloseOnAddDept"
      :reload="reload"
    ></EditLeavePeriod>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>
<!-- Zgewv#6uIWJn -->
<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
import { utils, writeFileXLSX } from "xlsx";
import ActionWarning from "../../../utils/actionWarning.vue";
// import Switches from 'vue-switches';
import moment from "moment";

export default {
  name: "LocationList",
  components: {
    Loader,

    CreateLeavePeriod: () =>
      import("@/components/CompanySetups/leavePeriods/create.vue"),
    AddDepartment: () =>
      import("@/components/CompanySetups/leavePeriods/addLeavePeriods.vue"),
    EditLeavePeriod: () =>
      import("@/components/CompanySetups/leavePeriods/editLeavePeriod.vue"),
    ActionWarning,
  },
  data() {
    return {
      showCreateLeavePeriod: false,
      showAddDepartment: false,
      loading: false,
      get_error: null,
      linemanagers: [],
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      selectedRow: null,
      locationDetails: null,
      message: null,
      title: null,
      showWarning: false,
      locationToDelete: null,
      searchInput: "",
      leavePeriodToEdit: {
        StartingDate: "",
        NumberOfPeriods: 0,
        PeriodLength: 0,
      },

      showEditLeavePeriod: false,
      create_success: "Location created successfully",
      add_dept_success: "Departments have been added successfully",
      del_error: null,
      showLocCrSuccess: false,
      showAddDepartmentSuccess: false,
      showLocDelSuccess: null,
      saved_departments: null,
      latestDate: null,

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,

          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "PeriodName",
          key: "PeriodName",
          title: "Period Name",
          headerAlign: "left",
          align: "left",
        },
        {
          field: "StartingDate",
          key: "StartingDate",
          title: "Starting Date",
          headerAlign: "left",
          align: "center",
          renderBodyCell: ({ row }) =>
            moment(row.StartingDate).format("DD/MM/YYYY"),
        },
        {
          field: "EndingDate",
          key: "Ending Date",
          title: "Ending Date",
          headerAlign: "left",
          align: "center",
          renderBodyCell: ({ row }) =>
            moment(row.EndingDate).format("DD/MM/YYYY"),
        },
        {
          field: "January Opening Date",
          key: "OpeningJanuaryDate",
          title: "January Opening Date",
          headerAlign: "left",
          align: "center",
          renderBodyCell: ({ row }) =>
            moment(row.OpeningJanuaryDate).format("DD/MM/YYYY"),
        },
        {
          field: "December Opening Date",
          key: "ClosingDecemberDate",
          title: "December Opening Date",
          headerAlign: "left",
          align: "center",
          renderBodyCell: ({ row }) =>
            moment(row.ClosingDecemberDate).format("DD/MM/YYYY"),
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getPeriods();
    this.setPageSizes();
  },

  methods: {
    createInfoObject() {
      return {
        PeriodName: "",
        StartingDate: "",
        EndingDate: "",
        OpeningJanuaryDate: "",
        ClosingDecemberDate: "",
      };
    },
    close() {
      this.$emit("close");
    },
    reload() {
      this.getPeriods();
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deletePeriod(this.locationToDelete);
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    handleEditButtonClick(leavePeriod) {
      // Handle the button click for the edit button
      //console.log(leavePeriod);
      this.leavePeriodToEdit = {
        ...leavePeriod,
        MonthStartDate: moment(leavePeriod.MonthStartDate).format("YYYY-MM-DD"), // override MonthStartDate with formatted value
      };
      //console.log(this.leavePeriodToEdit)
      this.showEditLeavePeriod = true;
    },
    handleDeleteButtonClick(period) {
      // Handle the button click for the delete button
      this.message = `You are about to delete ${period.PeriodName}!`;
      this.title = `Delete ${period.PeriodName} for ${period.StartingDate} - ${period.EndingDate}`;
      this.locationToDelete = period;
      this.showWarning = true;
    },
    handleClose() {
      this.showCreateLeavePeriod = false;
      this.showEditLeavePeriod = false;
    },
    handleCloseOnSuccess() {
      this.showCreateLeavePeriod = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getPeriods();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.showLocDelSuccess = null;
      }, 3000);
      this.getPeriods();
    },

    AddDepartment(row) {
      this.selectedRow = row;
      this.showAddDepartment = true;
    },

    handleCloseOnAddDept() {
      this.showAddDepartment = false;
      this.showAddDepartmentSuccess = true;
      setTimeout(() => {
        this.showAddDepartmentSuccess = false;
      }, 3000);
    },
    // /{organization}/setup/leave/period/v1/request
    getPeriods() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leave/period/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
              this.latestDate = response.data.Data[0];
            } else {
              this.get_error = response.data.StatusMessage;
              setTimeout(() => {
                this.get_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
            setTimeout(() => {
              this.get_error = null;
            }, 3000);
          }
        );
    },

    deletePeriod(row) {
      console.log(row)
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/timeoff/period/v1/delete`,
            {
              ...options,
              data: {
                PeriodId: row.Id
              }
            }
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.showLocDelSuccess = response.data.StatusMessage;
              this.handleDeleteOnSuccess();
            } else {
              this.del_error = response.data.StatusMessage;
              setTimeout(() => {
                this.del_error = null;
              }, 3000);
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 3000);
          }
        );
    },
    exportTemplate() {
      const ws = utils.json_to_sheet(this.tableData);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, "Data");

      writeFileXLSX(wb, "Periods.xlsx");
    },
  },
};
</script>

<style>
.custom-menu {
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  min-width: 120px;
  padding: 0.5rem 0;
  margin: 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
}
</style>
